// components/close-button/common/src/close-props.ts
var closeSizes = ["sm", "md", "lg"];
var defaultCloseButtonProps = {
  size: "md",
  surface: "primary",
  emphasis: "bold"
};

// components/close-button/common/src/close-style-sheet.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var closeStyleSheet = new StyleSheet(
  "close-button",
  (props) => {
    var _a;
    return createComponentClassDefinitions(props, createDefaultStyledClasses, (_a = props.theme.styleOverrides) == null ? void 0 : _a.closeButton);
  }
);
function createDefaultStyledClasses({
  theme,
  size = defaultCloseButtonProps.size,
  surface = defaultCloseButtonProps.surface,
  emphasis = defaultCloseButtonProps.emphasis,
  link
}) {
  const buttonSize = closeButtonSizeVariants[size].buttonSize;
  const iconSize = closeButtonSizeVariants[size].iconSize;
  let interactionShades = theme.getColorInteractionShades("primary", "minimal");
  if (surface in theme.surface && surface !== "none") {
    interactionShades = theme.getSurfaceInteractionShades(surface);
    interactionShades.border = interactionShades.text;
  } else if (surface in theme.status || surface in theme.color) {
    interactionShades = theme.getColorInteractionShades(
      surface,
      emphasis
    );
    if (emphasis === "bold" || emphasis === "minimal") {
      interactionShades.border = interactionShades.text;
    }
  }
  if (link) {
    interactionShades.text = theme.colorScheme.primary;
    interactionShades.border = interactionShades.text;
  }
  return {
    root: {},
    button: {
      border: 0,
      background: "transparent",
      color: interactionShades.text,
      display: "inline-flex",
      width: buttonSize,
      height: buttonSize,
      padding: 0,
      alignItems: "center",
      justifyContent: "center",
      "&:hover:not(:disabled)": {
        "#{icon}": {
          background: interactionShades.hover
        }
      },
      // Feb 4, 2022:  We needed to remove this because some apps, such as ION Dealbook are using
      //    Marquee Desktop / Openfin and using Chrome 80 where :focus-visible is not supported and
      //    throwing errors.  https://jira.site.gs.com/browse/UX-15248
      // '&:focus': {
      //     outline: 'none',
      //     '#{icon}': {
      //         color: focusColor,
      //     },
      // },
      // '&:focus-visible': {
      "&:focus:not(:disabled)": {
        outline: "none",
        "#{icon}": {
          borderColor: interactionShades.border
        }
      },
      "&:active:not(:disabled)": {
        "#{icon}": {
          background: interactionShades.active
        }
      },
      "&:disabled": {
        opacity: theme.state.disabledOpacity,
        "#{icon}:hover": {
          cursor: "default"
        }
      }
    },
    icon: {
      border: "1px solid transparent",
      borderRadius: "2px",
      width: iconSize,
      height: iconSize,
      transition: "background 0.15s linear",
      "&:hover": {
        cursor: "pointer"
      }
    }
  };
}
var closeButtonSizeVariants = {
  sm: {
    iconSize: "16px",
    buttonSize: "24px"
  },
  md: {
    iconSize: "20px",
    buttonSize: "32px"
  },
  lg: {
    iconSize: "24px",
    buttonSize: "44px"
  }
};

// components/close-button/common/src/close-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-close";
var getCloseRootClassNames = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};
var getButtonClassNames = (props) => {
  const { cssClasses, overrideClasses, buttonClassName } = props;
  return cx(
    cssClasses.button,
    overrideClasses && overrideClasses.button,
    buttonClassName,
    `${globalClassName}__button`
  );
};
var getIconClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(cssClasses.icon, overrideClasses && overrideClasses.icon, `${globalClassName}__icon`);
};
export {
  closeButtonSizeVariants,
  closeSizes,
  closeStyleSheet,
  defaultCloseButtonProps,
  getButtonClassNames,
  getCloseRootClassNames,
  getIconClassNames
};
//# sourceMappingURL=index.mjs.map
